<!--tab-->
<template>
    <div class="data-card-tab">
        <template v-for="(item,index) in tabList">
          <div :id="name+index" :key="index" :class="['data-card-tab-item',{'data-card-tab-active':curIndex==index}]" :style="'font-size:' + tabFontSize + '!important'"
            @click="switchTab(index)">{{item}}</div>
          <div class="data-card-tab-space" id="tab-space" :key="index+'space'"></div>
        </template>

        <div ref="line" class="data-card-tab-line"
          :style="'width:'+ width +'px;transform:translateX('+ left +'px);transition-duration: 0.3s;'"></div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            // 数据
            tabList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            name: {
                type: String,
                default: ''
            },
            indexKey: {
                type: String,
                default: ''
            },
            tabFontSize: {
                type: String,
                default: '12px'
            }

        },
        data () {
            return {
                curIndex: 0,
                width: 0,
                left: 0
            }
        },
        computed: {

        },
        methods: {
            switchTab (index) {
                this.curIndex = index
                let length = 0
                for (let i = 0; i < this.tabList.length; i++) {
                    let tabDiv = document.querySelector('#' + this.name + i)
                    if (i < index) {
                        length += tabDiv.offsetWidth + document.querySelector('#tab-space').offsetWidth
                    } else if (i === index) {
                        this.$nextTick(() => {
                            this.width = tabDiv.offsetWidth
                        })
                    }
                }
                this.left = length
                this.$emit('onSwitch', index, this.indexKey)
            }

        },
        mounted () {
            this.switchTab(0)
        }

    }
</script>

<style scoped lang="less">
@vv: 3.75vw;
.data-card-tab {
        display: flex;
        margin-top: 24/@vv;
        position: relative;

        &-item {

          font-size: 12/@vv;
          font-family: PingFangSC-Medium, PingFang SC;
        //   font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 14/@vv;
        }

        &-space {
          width: 16/@vv;
        }

        &-active {
          color: rgba(54, 179, 116, 1);
          font-weight: 700;
        }

        &-line {
          position: absolute;
          bottom: -6/@vv;
          left: 0;
          z-index: 1;
          width: 56/@vv;
          height: 2/@vv;
          background: rgba(54, 179, 116, 1);
        }
      }
</style>
